import { SITE_URL } from "./siteSeo";

export const AUTH_TAB_SYNC_CHANNEL = "mcverse-auth";

export const AUTH_TAB_SYNC_EVENTS = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
};

export function isLocalDevHost(hostname) {
  return (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname === "[::1]" ||
    hostname.endsWith(".local")
  );
}

/**
 * Returns a full redirect URL when the current host differs from the canonical
 * SITE_URL host. Skips redirect on local dev hosts.
 */
export function getCanonicalRedirectUrl(location) {
  const canonical = new URL(SITE_URL);

  if (isLocalDevHost(location.hostname)) {
    return null;
  }

  if (location.host === canonical.host) {
    return null;
  }

  return `${canonical.origin}${location.pathname}${location.search}${location.hash}`;
}

/**
 * Redirect bare-domain (or other non-canonical) visitors to SITE_URL origin.
 * Returns true when a redirect was initiated.
 */
export function redirectToCanonicalHostIfNeeded(location = window.location) {
  const target = getCanonicalRedirectUrl(location);
  if (!target) {
    return false;
  }

  location.replace(target);
  return true;
}

export function broadcastAuthTabSync(type) {
  if (typeof BroadcastChannel === "undefined") {
    return;
  }

  try {
    const channel = new BroadcastChannel(AUTH_TAB_SYNC_CHANNEL);
    channel.postMessage({ type });
    channel.close();
  } catch {
    // BroadcastChannel may be unavailable in some environments.
  }
}

export function subscribeAuthTabSync(handler) {
  if (typeof BroadcastChannel === "undefined") {
    return () => {};
  }

  let channel;
  try {
    channel = new BroadcastChannel(AUTH_TAB_SYNC_CHANNEL);
    channel.onmessage = (event) => {
      if (event.data?.type) {
        handler(event.data.type);
      }
    };
  } catch {
    return () => {};
  }

  return () => {
    channel.close();
  };
}
